import { createSlice } from "@reduxjs/toolkit";
import { AddCategory, UpdateCategory, GetCategoryList } from "services/other/category.service";
import { toast } from 'react-toastify';

export const categoryAddSlice = createSlice({
  name: "categoryAdd",
  initialState: {
    categoryAdd: {},
    categoryAddLoading: false,
    categoryAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddCategory.pending, (state) => {
      // toast.loading('We are adding the category 🤯')
      state.categoryAddLoading = true
    });

    builder.addCase(AddCategory.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New category added successfully 👌');

      state.categoryAdd = action.payload
      state.categoryAddLoading = false
      state.categoryAddError = null
    });

    builder.addCase(AddCategory.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the category 😣")

      state.categoryAddLoading = false
      state.categoryAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const categoryUpdateSlice = createSlice({
  name: "categoryUpdate",
  initialState: {
    categoryUpdate: {},
    categoryUpdateLoading: false,
    categoryUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateCategory.pending, (state) => {
      // toast.loading('We are updating the category 🤯')
      state.categoryUpdateLoading = true
    });

    builder.addCase(UpdateCategory.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.categoryUpdate = action.payload
      state.categoryUpdateLoading = false
      state.categoryUpdateError = null
    });

    builder.addCase(UpdateCategory.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the category 😣")

      state.categoryUpdateLoading = false
      state.categoryUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const categoryListSlice = createSlice({
  name: "categoryList",
  initialState: {
    categoryList: [],
    categoryListLoading: false,
    categoryListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetCategoryList.pending, (state) => {
      state.categoryListLoading = true
    });

    builder.addCase(GetCategoryList.fulfilled, (state, action) => {
      toast.dismiss();

      state.categoryList = action.payload
      state.categoryListLoading = false
      state.categoryListError = null
    });

    builder.addCase(GetCategoryList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the category 😣")

      state.categoryListLoading = false
      state.categoryListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});